import {
  Component,
  OnInit,
  Input,
  EventEmitter,
  Output,
  OnChanges,
  SimpleChanges,
  ViewChild,
  TemplateRef,
} from '@angular/core';
import routeTable from '../../../../utility/routeTable';
import { ToastrService } from 'ngx-toastr';
import {
  LotService,
  WatchListService,
  WebStorageService,
} from '../../../../services';
import { Router, ActivatedRoute } from '@angular/router';
import { FormControl, Validators } from '@angular/forms';
import { BulkBidSubmissionResult, LotPublic } from '../../../../models';
import { AppValidators } from '../../../../core/validators/app-validators';
import {
  trigger,
  state,
  style,
  transition,
  animate,
} from '@angular/animations';
import { BidService, BulkBid } from '../../../../services/bid.service';
import constants from '../../../../utility/constants';
import { AuctionTimeService } from '../../../../services/auction-time.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import {  Subscription } from 'rxjs';

export interface BidInfo {
  auctionAndLotNumber: string;
  bidCount: number;
  bidType: number;
  bulkLotReservePrice: number;
  lotStatus: number;

  currentBid: number;
  highestBid: number;
  highestBidders: Array<number> | null;
  isBiddingPaused: boolean;
  loosers: Array<number> | null;
  lotEndTimeUtc: string;
  lotId: number;
  nextRequiredBid: number;
  soldAt: number;
  soldTo: number;
  soldToName: string;
  higherBidders: any;
  extendedByMinutes: number;
  timeLeft: string;
  willSell?: boolean;
  price: number;
  recentBid: number;
  soldForBid: number;
}

@Component({
  selector: 'auction-lot-card',
  templateUrl: './auction-lot-card.component.html',
  styleUrls: ['./auction-lot-card.component.css'],
  animations: [
    trigger('submit', [
      state(
        'noBlink',
        style({
          border: '1px #ffffff solid',
          background: '#ffffff',
        })
      ),
      state(
        'redBlink',
        style({
          border: '1px #ff1a1a solid',
          background: '#ff9999',
        })
      ),
      transition('noBlink=>redBlink', animate('250ms')),
      transition('redBlink=>noBlink', animate('1500ms')),
    ]),
  ],
})
export class AuctionLotCardComponent implements OnInit, OnChanges {
  @Input() isUserRegistered: boolean;
  @Input('lotData') eachLotData: LotPublic;
  @Input() latestLotData: LotPublic;
  @Input() isItWatchList: boolean = false;
  @Input() isItActiveBidList: boolean = false;
  @Input() serverTime: string = null;
  @Input('isListView') showListView: boolean = true;
  @Input('pageChanged') pageChange: boolean = true;
  @Input() bulkBid: boolean;
  @Input() bulkBidResult: BulkBidSubmissionResult[];
  @Input() featuredSyncedInfo;
  @Output('selectedLotData') selectedLot = new EventEmitter<
    LotPublic | number
  >();
  @Output() submitBulkBid = new EventEmitter<boolean>();
  modalRef: BsModalRef;
  submitState: string;

  isAddedToWatchlist: boolean = false;
  isLotClosed: boolean = false;

  soldStatuses = constants.common.soldStatus;

  loggedInUser = 0;
  showTimer: boolean = true;
  private subscriptions: Array<Subscription> = [];

  minBid: number = constants.common.bid.bidMinAmount;
  maxBid: number = constants.common.bid.bidMaxAmount;

  loader: boolean = false;
  auctionStatuses = constants.common.auctionStatus;
  errorMsg: string = null;
  isUserHighestBidder: boolean = false;
  biddingAmount: FormControl;

  readOnlyCatalog: boolean;

  isLowConnectionMode: boolean = false;

  lotType = constants.common.lotTypes;
  responseData: any;
  @ViewChild('quickBidModal', { static: false })
  quickBidModal: TemplateRef<any>;
  userFullName: string;

  changeInAmount: boolean = false;

  constructor(
    private storage: WebStorageService,
    private router: Router,
    private route: ActivatedRoute,
    private toastr: ToastrService,
    private watchListService: WatchListService,
    private lotService: LotService,
    private bidService: BidService,
    private auctionTimer: AuctionTimeService,
    private modalService: BsModalService
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes) {
      if (changes?.serverTime) {
        this.eachLotData.lotStartTimeUtc = changes.serverTime.currentValue;
      }
      if (changes?.bulkBidResult) {
        this.checkLotBulkBidResult(changes?.bulkBidResult.currentValue);
      }
      if (changes?.latestLotData) {
        this.mapBidInfo(changes?.latestLotData.currentValue);
        this.submitState = 'redBlink';
      }
      if (changes?.featuredSyncedInfo) {
        let val = changes?.featuredSyncedInfo.currentValue;
        if (this.eachLotData.isFeatured) {
          if (val) {
            if (val > 0) {
              this.biddingAmount.reset();
            }
          }
        }
      }
    }
  }

  ngOnInit() {
    let checkLotClosed = this.auctionTimer.isLotClosingBegun(
      this.eachLotData?.lotEndTimeUtc
    );

    this.submitState = 'noBlink';
    this.biddingAmount = new FormControl(null, [
      Validators.minLength(1),
      AppValidators.noWhitespace,
      AppValidators.onlyNumeric,
      Validators.min(this.minBid),
      Validators.max(this.maxBid),
    ]);

    this.isAddedToWatchlist = this.eachLotData.watchListId > 0 ? true : false;

    var loggedInData = this.storage.getBuyer()?.loggedIn;
    if (loggedInData == true) {
      this.loggedInUser = this.storage.getBuyer()?.currentUser?.user?.id;
      this.userFullName =
        this.storage.getBuyer()?.currentUser?.user?.firstName +
        ' ' +
        this.storage.getBuyer()?.currentUser?.user?.lastName;
      this.checkLotConnectionMode();
    }

    this.readOnlyCatalog = this.eachLotData.auction.saleType.isCatalogReadOnly;

    this.checkHigherBidder(this.eachLotData.highestBidder);

    if (
      this.loggedInUser > 0 &&
      this.eachLotData.loggedInUser?.isApproved &&
      (this.eachLotData.auction.auctionStatus == this.auctionStatuses.past ||
        checkLotClosed) &&
      !this.readOnlyCatalog
    ) {
      this.showTimer = false;
      this.isLotClosed = true;
    }

    this.biddingAmount.valueChanges.subscribe((value: number) => {
      this.dataModelForBulkBid(value);
    });

    this.eachLotData.outbid = this.findOutbid(this.eachLotData);
  }

  private checkLotConnectionMode() {
    let storedValue = this.storage.getBuyer();
    if (storedValue)
      this.isLowConnectionMode = storedValue?.lotLowConnectionMode;
  }

  refreshWholePage() {
    location.reload();
  }

  private checkAuctionDeactivated() {
    if (!this.readOnlyCatalog) {
      this.toastr.info(
        `Unfortunately ${this.eachLotData.auction.auctionCode} is no longer available for bidding and you will be notified if and when the auction becomes available for bidding again`,
        constants.common.toast.infoTitle,
        constants.common.toast.config
      );
    }
    if (this.readOnlyCatalog) {
      this.toastr.info(
        `Unfortunately ${this.eachLotData.auction.auctionCode} is deactivated and you will be notified if and when the auction becomes available again`,
        constants.common.toast.infoTitle,
        constants.common.toast.config
      );
    }
    this.router.navigateByUrl('/');
  }

  private dataModelForBulkBid(inputedValue: number) {
    this.eachLotData.newBid = this.biddingAmount.value;
    if (inputedValue) this.selectedLot.emit(this.eachLotData);
    else this.selectedLot.emit(this.eachLotData.id);
  }

  isTimeReached(isReached: boolean) {
    if (isReached) {
      this.getLotResults();
      this.showTimer = false;
      this.isLotClosed = true;
    }
  }

  mapBidInfo(res: BidInfo) {
    if (this.eachLotData.id === res?.lotId) {
      this.changeInAmount =
        +this.eachLotData.nextRequiredBid !== +res.nextRequiredBid;
      this.eachLotData.bidCount = res.bidCount;
      this.eachLotData.currentBid = res.currentBid;
      this.eachLotData.highestBid = res.highestBid;
      this.eachLotData.highestBidder = res.highestBidders;
      this.eachLotData.nextRequiredBid = res.nextRequiredBid;
      this.eachLotData.lotEndTimeUtc = res.lotEndTimeUtc;
      this.eachLotData.soldTo = res.soldTo;
      this.eachLotData.soldAt = res.soldAt;
      this.eachLotData.extendedByMinutes = res.extendedByMinutes;
      this.eachLotData.timeLeft = res.timeLeft;
      this.eachLotData.isBiddingPaused = res.isBiddingPaused;
      this.eachLotData.lotStatus = res.lotStatus;
      this.eachLotData.willSell = res?.willSell;
      this.eachLotData.loosers = res?.loosers;
      this.eachLotData.outbid = this.findOutbid(this.eachLotData, true);
      this.checkHigherBidder(res.highestBidders);
    }
  }

  endState() {
    this.submitState = 'noBlink';
  }

  goToViewLotDetail(lotNumber: string) {
    this.router.navigate([lotNumber], {
      relativeTo: this.route,
      queryParams: { returnTo: this.router.url },
    });
  }

  goToViewLotDetailsFromWatchList(auctionCode, lotNumber) {
    this.router.navigate(['/', auctionCode, 'lots', lotNumber], {
      queryParams: { returnTo: this.router.url, lotId: this.eachLotData.id },
    });
  }

  addToWatchList(lotId, lotNumber) {
    let model = {
      lotId: lotId,
      auctionId: this.eachLotData.auction.id,
    };
    const addToWatchList = this.watchListService.addToWatchList(model).subscribe((res: any) => {
      this.toastr.success(
        `Lot # ${lotNumber} added to Watchlist`,
        constants.common.toast.successTitle,
        constants.common.toast.config
      );
      this.isAddedToWatchlist = true;
    });
    this.subscriptions.push(addToWatchList)
  }

  removeFromWatchList(lotId, lotNumber) {
    let model = {
      lotId: lotId,
      auctionId: this.eachLotData.auction.id,
    };
    const removeFromwatchList = this.watchListService.removeFromWatchList(model).subscribe((res: any) => {
      this.toastr.success(
        `Lot # ${lotNumber} removed from Watchlist`,
        constants.common.toast.successTitle,
        constants.common.toast.config
      );
      this.isAddedToWatchlist = false;
    });
    this.subscriptions.push(removeFromwatchList)
  }

  private checkHigherBidder(highestBidders: Array<number> | null) {
    if (highestBidders != null) {
      let isHighest: number = highestBidders.find(
        (i) => i == this.eachLotData.loggedInUser?.userId
      );
      this.isUserHighestBidder = isHighest > -1 ? true : false;
    }
  }

  goToRegister(auctionCode) {
    this.router.navigate([auctionCode, routeTable.public.auctionRegister], {
      queryParams: { returnTo: this.router.url },
    });
  }

  goToAuctionTitle(auctionCode) {
    this.router.navigate([auctionCode], {
      queryParams: { returnTo: this.router.url },
    });
  }

  onSubmit(isQuickBid: boolean = false) {
    this.changeInAmount = false;
    if (isQuickBid) {
      this.modalRef = this.modalService.show(this.quickBidModal, {
        class: 'custom-popup modal-dialog-centered',
        ignoreBackdropClick: true,
        keyboard: false,
      });
      this.modalRef.onHidden.subscribe(() => {
        this.changeInAmount = false;
      });
    } else {
      this.submitBidByApi(isQuickBid);
    }
  }

  findLooser(): number {
    if (this.eachLotData.loosers)
      return this.eachLotData.loosers?.findIndex(
        (i) => i == +this.loggedInUser
      );
    return -1;
  }

  checkLotBulkBidResult(values: BulkBidSubmissionResult[]) {
    if (values && values.length) {
      let lotValue = values.find((val) => val.lotId == this.eachLotData.id);
      if (lotValue && lotValue.message) {
        this.errorMsg = lotValue.isSuccess ? '' : lotValue.message;
        this.biddingAmount.reset();
        return;
      }

      if (lotValue && lotValue.isRemoved) {
        this.biddingAmount.reset();
      }
    }
  }

  getLotDataInApi() {
    this.loader = true;
    const lotDetail = this.lotService
      .getLotDetail(
        this.eachLotData.id,
        this.eachLotData.auction.auctionCode,
        this.eachLotData.lotNumber
      )
      .subscribe(
        (res) => {
          this.eachLotData = res;
          this.checkHigherBidder(res.highestBidder);
          this.loader = false;
        },
        (err) => {
          Error(err);
          this.loader = false;
        }
      );
      this.subscriptions.push(lotDetail)
  }

  findOutbid(item, isShowMessage = false) {
    let index =
      item.loosers && item.loosers?.length > 0
        ? item.loosers?.findIndex((x) => x == this.loggedInUser)
        : -1;
    let index1 =
      item.highestBidder && item.highestBidder?.length > 0
        ? item.highestBidder?.findIndex((x) => x == this.loggedInUser)
        : -1;
    if (index > -1 && index1 == -1) {
      return true;
    } else {
      return false;
    }
  }

  submitBidByApi(isQuickBid: boolean = false) {
    this.errorMsg = null;
    let bidAmount: number;

    if (!isQuickBid) {
      if (this.biddingAmount.invalid) return;
      bidAmount = +this.biddingAmount.value;
      if (
        this.bulkBid ||
        (this.bulkBidResult &&
          this.bulkBidResult.filter((it) => it.isRemoved == false).length > 1)
      ) {
        this.submitBulkBid.emit(true);
        return;
      } else this.submitBulkBid.emit(false);
    } else {
      bidAmount = +this.eachLotData.nextRequiredBid;
    }

    this.loader = true;

    let model: BulkBid = {
      auctionId: this.eachLotData.auction.id,
      lotAmount: [
        {
          lotId: this.eachLotData.id,
          amount: bidAmount,
        },
      ],
      userId: this.eachLotData.loggedInUser.userId,
      paddleNumber: this.eachLotData.loggedInUser.paddleNumber,
      proxyUserId: null,
    };

    this.bidService
      .submitPublicBulkBid(model)
      .toPromise()
      .then((res: any) => {
        res = res[0];
        this.loader = false;
        if (res.isSuccess) {
          this.toastr.success(
            res.message,
            constants.common.toast.successTitle,
            constants.common.toast.config
          );
          this.biddingAmount.reset();
        } else {
          this.errorMsg = res.message;
        }
        if (res.isDeactivated) {
          this.checkAuctionDeactivated();
        }
      })
      .catch((err) => {
        this.loader = false;
        this.toastr.error(
          err,
          constants.common.toast.errorTitle,
          constants.common.toast.config
        );
      });
    this.closeReviewModal();
  }

  closeReviewModal() {
    this.changeInAmount = false;
    this.modalRef.hide();
  }

  private getLotResults() {
    this.loader = true;
    const lotResult = this.bidService.getLotResult(this.eachLotData.id).subscribe(
      (res) => {
        this.loader = false;
        this.mapBidInfo(res);
      },
      () => (this.loader = false)
    );
    this.subscriptions.push(lotResult)
  }

  ngOnDestroy() {
    this.subscriptions.forEach((sub: Subscription) => {
      sub.unsubscribe();
    });
  }
}
